import { useEffect, useRef, useState } from "react";
import { pop } from "@/lib/babySound";

const COLORS = ["#F28C38", "#6BB3E0", "#9BD08A", "#F2C94C", "#E58FB8", "#A68BE0"];

export const BubblePop = () => {
  const [bubbles, setBubbles] = useState([]);
  const [bursts, setBursts] = useState([]);
  const id = useRef(0);
  useEffect(() => {
    const t = setInterval(() => setBubbles((b) => b.length >= 12 ? b : [...b, { id: id.current++, x: 5 + Math.random() * 80, size: 70 + Math.random() * 70, color: COLORS[Math.floor(Math.random() * COLORS.length)], dur: 7 + Math.random() * 5 }]), 750);
    return () => clearInterval(t);
  }, []);
  const hit = (b, e) => {
    pop();
    setBubbles((x) => x.filter((y) => y.id !== b.id));
    const burst = { id: b.id, x: e.clientX, y: e.clientY, color: b.color };
    setBursts((x) => [...x, burst]);
    setTimeout(() => setBursts((x) => x.filter((y) => y !== burst)), 600);
  };
  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="game-bubbles">
      {bubbles.map((b) => (
        <button key={b.id} onPointerDown={(e) => hit(b, e)} onAnimationEnd={() => setBubbles((x) => x.filter((y) => y.id !== b.id))} aria-label="Bubble" data-testid="bubble"
          className="absolute rounded-full baby-float" style={{ left: `${b.x}%`, width: b.size, height: b.size, animationDuration: `${b.dur}s`,
            background: `radial-gradient(circle at 30% 30%, rgba(255,255,255,0.9), ${b.color}cc 45%, ${b.color}55 70%)`, boxShadow: `0 0 30px ${b.color}66` }} />
      ))}
      {bursts.map((s) => <span key={s.id} className="absolute pointer-events-none baby-burst rounded-full" style={{ left: s.x - 60, top: s.y - 60, width: 120, height: 120, border: `6px solid ${s.color}` }} />)}
    </div>
  );
};
